/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function DateInput({
  children,
  viewPath = "/DesignSystem/AppsLauncherProperties/Content/ActiveStep/None/DateInput",
  onChange,
  isSubmitting
  
}) {
let selectedValueValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'value',
format: fromFormat.dateISOIn,
})
let selectedValueChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'value',
formatOut: fromFormat.dateShortOut,
})
let stepsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'steps',
})
let selectedNameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="date"
 placeholder="mm/dd/yyyy"
 data="selected.value"
 format="/Data/format.js dateISOIn"
 formatOut="/Data/format.js dateShortOut"
 validate="/Data/validate.js date"
 value={selectedValueValueData}
 onChange={selectedValueChangeData}
 data="steps"
 disabled={stepsIsSubmittingData}
 data="selected.required"
 required={undefined}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 data="selected.name"
 text={selectedNameValueData}
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}